import { GetBonusAccountTransactionsResponseV1 } from 'api/version1';
import clsx from 'clsx';
import { GET_ENUMS, GET_PARAMS } from 'const';
import { usePrepareLink } from 'hooks/router';
import { useNavigate } from 'react-router-dom';

import style from './style.module.css';

const Transaction = ({
  transaction,
  date,
}: {
  transaction: GetBonusAccountTransactionsResponseV1.ResponseItem;
  date: string;
}) => {
  const navigate = useNavigate();

  const { orderId, orderNumber, type, amount } = transaction;

  const orderLink = usePrepareLink({
    query: {
      [GET_PARAMS.page]: GET_ENUMS.page.orders,
    },
    pushToQuery: {
      [GET_PARAMS.orderId]: orderId,
    },
  });

  const sign = type === 'WITHDRAW' ? '-' : '+';

  return (
    <button
      type='button'
      className={style.root}
      // onClick={() => navigate(orderLink, { replace: true })}
    >
      <div className={style.header}>
        <p className={style.orderNumber}>{`Заказ №${orderNumber}`}</p>
        <p className={style.date}>{date}</p>
      </div>

      <div className={style.divider} />

      <div className={style.footer}>
        <p className={style.label}>Икринки:</p>

        <p
          className={clsx(
            style.amount,
            type === 'WITHDRAW' && style.withdrawAmount,
          )}
        >
          {`${sign}${amount}`}
        </p>
      </div>
    </button>
  );
};

export default Transaction;